
import React from 'react'
import api from '../api'

export default function Orders(){
  const [orders,setOrders]=React.useState([]);
  React.useEffect(()=>{ load(); },[]);
  async function load(){ const r = await api.get('/tables'); /* get orders by scanning tables */ 
    const tables = r.data;
    let all = [];
    for(const t of tables){
      const res = await api.get('/tables/'+t._id+'/orders');
      const list = res.data.map(o=>({ ...o, tableName: t.name }));
      all = all.concat(list);
    }
    setOrders(all);
  }
  async function del(id){ if(!confirm('Delete?')) return; await api.delete('/orders/'+id); await load(); }
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Orders</h2>
      <div className="grid gap-2">
        {orders.map(o=> (
          <div key={o._id} className="bg-white p-3 rounded shadow">
            <div className="flex justify-between"><div>Table: {o.tableName}</div><div>Total: ₹ {o.total}</div></div>
            <div className="mt-2">
              <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={()=>del(o._id)}>Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
